import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OtpService } from '../../auth/services/otp.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['../verify-request/verify-request.component.css'],
  standalone: false
})
export class VerifyOtpComponent implements OnInit {
  token?: string;
  isLinkExpired = false;
  wentWrong = false;
  success = false;

  constructor(activatedRoute: ActivatedRoute, private router: Router, private verifyOtp: OtpService) {
    activatedRoute.queryParams.subscribe(async params => {
      this.token = params['token'];

      if (!this.token) {
        this.router.navigate(['/']);
      } else {
        try {
          await this.verifyOtp.verifySmsLink(this.token).then(() => { this.success = true });
        } catch (error) {
          console.error('Error decoding token:', error);
          this.wentWrong = true;
        }
      }

    });
  }

  toDashboard() {
    this.router.navigate(['/']);
  }

  ngOnInit() { }

}
